import { render } from "./Skill.vue?vue&type=template&id=c8671148"
import script from "./Skill.vue?vue&type=script&lang=ts"
export * from "./Skill.vue?vue&type=script&lang=ts"

import "./Skill.vue?vue&type=style&index=0&id=c8671148&lang=scss"
script.render = render

export default script